import { render, staticRenderFns } from "./AnnotationsList.vue?vue&type=template&id=5c79d54f&scoped=true"
import script from "./AnnotationsList.vue?vue&type=script&lang=js"
export * from "./AnnotationsList.vue?vue&type=script&lang=js"
import style0 from "./AnnotationsList.vue?vue&type=style&index=0&id=5c79d54f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c79d54f",
  null
  
)

export default component.exports